import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { instance } from "Actions/AxiosInstance";
import DrawerHeader from "Component/Headers/drawerHeader";
import Payrollwidgetselector from "Component/Payrollwidget/selector";
import { ErrorMessages } from "Constants";

function ChooseStatutory(props) {
  const {
    closeDrawer,
    enqueueSnackbar,
    getallmastercomponents,
    getallsalarycomponents,
  } = props;
  const [allstatutorycomponents, setallstatutorycomponents] = useState([]);
  const [backupcomponents, setbackupcomponents] = useState([]);
  useEffect(() => {
    instance
      .post("payroll/getallmastercomponent", {
        isstatutory: true,
        isexcludeselected: true,
      })
      .then((resp) => {
        if (get(resp, "data.result[0]", "")) {
          setallstatutorycomponents(get(resp, "data.result", []));
          setbackupcomponents(get(resp, "data.result", []));
        } else {
          enqueueSnackbar(ErrorMessages.E1460, { variant: "error" });
          closeDrawer();
        }
      })
      .catch((error) => {
        enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
        closeDrawer();
      });
    return () => {
      // cleanup
    };
  }, []);

  function onSave() {
    if (allstatutorycomponents
      .filter((x) => x.isselected).length > 0) {
      instance.post("payroll/choosestatutorycomponent", {
        mastercomponentids: allstatutorycomponents
          .filter((x) => x.isselected)
          .map((x) => x.displayvalue)
          .join(","),
      })
      .then(() => {
        enqueueSnackbar(ErrorMessages.E0000, { variant: "success" });
        getallmastercomponents();
        getallsalarycomponents();
        closeDrawer();
      });
    } else {
      enqueueSnackbar("Please select at least one component", { variant: "error" });
    }
  }

  function onSearch(value) {
    if (value) {
      const filterList = allstatutorycomponents.filter(
        (item) =>
          item.displayname.toLowerCase().search(value.toLowerCase()) !== -1,
      );
      setallstatutorycomponents(filterList);
    } else {
      setallstatutorycomponents(backupcomponents);
    }
  }

  function onSelect(comp) {
    let backupcomponentslist = backupcomponents;
    const allcomps = allstatutorycomponents.map((x) => ({
      ...x,
      isselected:
        x.displayvalue == comp.displayvalue ? !x.isselected : x.isselected,
    }));
    backupcomponentslist = backupcomponentslist.map((x1) => (allcomps.find((y) => y.displayvalue == x1.displayvalue)
    ? allcomps.find((y) => y.displayvalue == x1.displayvalue)
    : x1));
    setallstatutorycomponents(allcomps);
    setbackupcomponents(backupcomponentslist);
  }

  return (
    <div>
      <DrawerHeader
        closeDrawer={closeDrawer}
        header="Choose Statutory Components"
        onSave={onSave}
        onSearch={(e) => onSearch(e.target.value)}
      />
      <div className="salary-component-wrapper thin-scroll1 margin-top-24">
        {allstatutorycomponents.map((x) => (
          <Payrollwidgetselector data={x} onselect={onSelect} />
        ))}
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(ChooseStatutory));
